import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminSecurityCenter = lazy(() => import("@/pages/admin/AdminSecurityCenter"));

export const Route = createFileRoute("/admin/security")({
  component: AdminSecurityCenter,
});
